import FeedbackSuccess from '../../../components/atoms/feedbacks/feedback-success'

export default {
  components: { FeedbackSuccess },
  data() {
    return {
      isInformationMailChecked: true,
      isUsableGiftChecked: true,
      isFeedbackShowable: false,
      message: ''
    }
  },
  mounted() {
    const noticeFeedbackMessage = document.querySelector('#flash_message').value

    if (noticeFeedbackMessage) {
      this.showFeedback(noticeFeedbackMessage)
    }

    const informationMail = document.querySelector('#receive_information_mail')
      .value

    if (informationMail === 'false') {
      this.isInformationMailChecked = false
    }

    const usableGiftNotification = document.querySelector(
      '#receive_usable_gift_mail'
    ).value

    if (usableGiftNotification === 'false') {
      this.isUsableGiftChecked = false
    }
  },
  methods: {
    enterFeedback() {
      setTimeout(() => {
        this.isFeedbackShowable = false
      }, 3000)
    },
    showFeedback(message) {
      this.isFeedbackShowable = true
      this.message = message
    },
    checkInformationMail() {
      this.isInformationMailChecked = !this.isInformationMailChecked
    },
    checkUsableGift() {
      this.isUsableGiftChecked = !this.isUsableGiftChecked
    }
  }
}
